import React, { useState } from "react";
import './staff-modules.css';
const SAMPLE_NOTICES = [
  {
    id: 1,
    title: "Monthly Staff Meeting",
    date: "2025-09-05",
    content: "The monthly staff meeting will be held on 10th September at 12:00 PM in the conference hall.",
    author: "Principal"
  },
  {
    id: 2,
    title: "Clinical Posting Update",
    date: "2025-08-28",
    content: "All GNM 2nd-year students should report to the new General Ward for the next rotation.",
    author: "Clinical Coordinator"
  }
];

export default function Notices() {
  const [notices, setNotices] = useState(SAMPLE_NOTICES);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: "",
    date: "",
    content: "",
    author: ""
  });

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!form.title || !form.content || !form.date || !form.author) return;
    setNotices([
      { ...form, id: Date.now() },
      ...notices
    ]);
    setForm({ title: "", date: "", content: "", author: "" });
    setShowForm(false);
  };

  return (
    <div className="module-wrapper">
      <h2>Notices & Circulars</h2>
      <p>
        View important college notices and circulars. Staff can add new notices for students and other staff members.
      </p>
      <div className="module-actions">
        <button className="primary-action" onClick={() => setShowForm(s => !s)}>
          {showForm ? "Cancel" : "Add New Notice"}
        </button>
      </div>
      {showForm && (
        <form className="notice-form" onSubmit={handleFormSubmit}>
          <div className="form-row">
            <label htmlFor="title">Title:</label>
            <input type="text" name="title" id="title" value={form.title} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label htmlFor="date">Date:</label>
            <input type="date" name="date" id="date" value={form.date} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label htmlFor="author">Author:</label>
            <input type="text" name="author" id="author" value={form.author} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label htmlFor="content">Content:</label>
            <textarea name="content" id="content" value={form.content} onChange={handleInputChange} required rows={3} />
          </div>
          <button type="submit" className="primary-action">Publish Notice</button>
        </form>
      )}
      <div className="notices-list">
        {notices.length === 0 && (
          <div className="empty-message">No notices available.</div>
        )}
        {notices.map(notice => (
          <div className="notice-card" key={notice.id}>
            <div className="notice-header">
              <span className="notice-title">{notice.title}</span>
              <span className="notice-date">{new Date(notice.date).toLocaleDateString()}</span>
            </div>
            <div className="notice-content">{notice.content}</div>
            <div className="notice-footer">By: {notice.author}</div>
          </div>
        ))}
      </div>
    </div>
  );
}